var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * EditBox component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconEditBox extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6134 2.66221C18.7122 2.62105 18.8182 2.59985 18.9253 2.59985C19.0323 2.59985 19.1383 2.62105 19.2371 2.66221C19.3359 2.70338 19.4256 2.7637 19.501 2.8397L19.5031 2.84188L21.1576 4.49637L21.1598 4.49854C21.2358 4.57392 21.2961 4.6636 21.3373 4.76241C21.3785 4.86122 21.3997 4.9672 21.3997 5.07424C21.3997 5.18128 21.3785 5.28726 21.3373 5.38607C21.2961 5.48488 21.2358 5.57456 21.1598 5.64994L21.1567 5.65304L12.4107 14.4297L9.00545 15.0426L9.57424 11.5844L18.3465 2.84281L18.3496 2.8397C18.4249 2.7637 18.5146 2.70338 18.6134 2.66221ZM18.9253 1.09985C18.6202 1.09985 18.3182 1.16026 18.0366 1.27757C17.7557 1.39459 17.5007 1.56594 17.2862 1.78176L17.2846 1.7834L8.34405 10.6927C8.23262 10.8037 8.15892 10.947 8.13339 11.1022L7.35297 15.8472C7.31343 16.0876 7.39313 16.3323 7.56671 16.5032C7.74029 16.6742 7.9861 16.7502 8.22589 16.7071L12.9084 15.8642C13.0594 15.837 13.1985 15.7642 13.3068 15.6555L22.2161 6.71494L22.2178 6.71325C22.4336 6.49878 22.6049 6.2438 22.7219 5.96293C22.8393 5.68134 22.8997 5.3793 22.8997 5.07424C22.8997 4.76918 22.8393 4.46714 22.7219 4.18554C22.6048 3.90443 22.4333 3.64924 22.2172 3.43465L22.2161 3.43354L20.566 1.7834L20.5647 1.78214C20.3502 1.56614 20.095 1.39467 19.814 1.27757C19.5324 1.16025 19.2303 1.09985 18.9253 1.09985ZM2.8371 5.18769C2.98916 5.03562 3.1954 4.9502 3.41045 4.9502H8.09298C8.50719 4.9502 8.84298 4.61441 8.84298 4.2002C8.84298 3.78598 8.50719 3.4502 8.09298 3.4502H3.41045C2.79758 3.4502 2.20981 3.69366 1.77644 4.12703C1.34307 4.56039 1.09961 5.14816 1.09961 5.76104V20.589C1.09961 21.2019 1.34307 21.7897 1.77644 22.2231C2.20981 22.6564 2.79758 22.8999 3.41045 22.8999H18.2385C18.8513 22.8999 19.4391 22.6564 19.8725 22.2231C20.3058 21.7897 20.5493 21.2019 20.5493 20.589V15.9065C20.5493 15.4923 20.2135 15.1565 19.7993 15.1565C19.3851 15.1565 19.0493 15.4923 19.0493 15.9065V20.589C19.0493 20.8041 18.9639 21.0103 18.8118 21.1624C18.6597 21.3145 18.4535 21.3999 18.2385 21.3999H3.41045C3.1954 21.3999 2.98916 21.3145 2.8371 21.1624C2.68504 21.0103 2.59961 20.8041 2.59961 20.589V5.76104C2.59961 5.54599 2.68504 5.33975 2.8371 5.18769Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconEditBox.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconEditBox.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconEditBox.prototype, "size", void 0);
if (customElements.get('cat-icon-edit-box') === undefined) {
    customElements.define('cat-icon-edit-box', BlocksIconEditBox);
}
